"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID_STORAGE = exports.UUID = exports.UuidManager = exports.createUUID = void 0;
const UUID_STORAGE = 'cas-js:uuid';
exports.UUID_STORAGE = UUID_STORAGE;
const createUUID = () => ('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
}));
exports.createUUID = createUUID;
class UuidManager {
    constructor(uuid) {
        this.uuid = this.getFromStorage();
        if (this.uuid)
            return;
        this.uuid = uuid || createUUID();
        this.setIntoStorage();
    }
    getFromStorage() {
        return localStorage.getItem(UUID_STORAGE);
    }
    setIntoStorage() {
        return localStorage.setItem(UUID_STORAGE, this.uuid);
    }
    get() {
        return this.uuid;
    }
}
exports.UuidManager = UuidManager;
const uuidManager = new UuidManager();
const UUID = uuidManager.get();
exports.UUID = UUID;
